import { render } from "./건강증진센터.vue?vue&type=template&id=1a5bb90a"
import script from "./건강증진센터.vue?vue&type=script&lang=js"
export * from "./건강증진센터.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__